var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'model/base'], function($, core, BaseModel) {
  var RegionModel;
  return RegionModel = (function(_super) {

    __extends(RegionModel, _super);

    function RegionModel() {
      RegionModel.__super__.constructor.apply(this, arguments);
    }

    RegionModel.prototype.pathRoot = core.getConfig().apiPrefix + 'region.json';

    RegionModel.prototype.defaults = function() {
      return {
        countryCode: null,
        regionCode: null,
        name: null,
        taxPercent: null
      };
    };

    return RegionModel;

  })(BaseModel);
});
